import React from "react";
import TopNavbarItem from "./TopNavBarItem";
import TopNavbarBrand from "./TopNavbarBrand";
import imagesMap from "../../../../assets/data/imagesMap"

const TopNavbar = props => {

  const { sceneSetting, appConfig, onStepChange, zoom, resetScene } = props;
  const { levelsSetting, currentStep, completedStep } = sceneSetting;
  let classes = "top-navbar"
  if (zoom) classes += " closed"
  const { companyInfo } = appConfig; 
  const renderItems = () => {
    if (levelsSetting.length) {
      return levelsSetting.map((item, index) => {
        return (
          <TopNavbarItem
            action={() => onStepChange('direct', index)}
            completed={completedStep > index}
            disabled={completedStep < index}
            active={currentStep === item.id}
            name={item.name}
            key={item.alias}
          />
        );
      });
    } else {
      return <div style={{ color: "white" }}>loading</div>;
    }
  };
  if (companyInfo) {
    return (
      <div className={classes}>
        <TopNavbarBrand logo={imagesMap[companyInfo.logoImgAlias]}/>
        {renderItems()}
        <TopNavbarItem
            action={() => resetScene()}
            name="reset"
          />
      </div>
    );
  } else {
    return (
      <div>loading</div>
    )
  }
  
};

export default TopNavbar;
